<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-4" v-if="checkForPermission(add_warehouse_permission)">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Add a warehouse</h4>
            <new-warehouse-form-component button_text="Add Warehouse" @warehouseAction="addWarehouse"/>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="card min-height">
          <div class="card-body">
            <h4 class="card-title mb-4">All Warehouses</h4>
            <TableLoading v-if="warehouses.page === 0"/>
            <div v-else>
              <warehouse-table :rows="warehouses.objects" @updateWarehouse="updateWarehouses"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import NewWarehouseFormComponent from "@/components/warehouse/new-warehouse-form-component";
import WarehouseTable from "@/components/warehouse/warehouse-table";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {ALL_WAREHOUSES} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Warehouses",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, WarehouseTable, NewWarehouseFormComponent, PageHeader, Layout},
  name: "warehouses",
  data() {
    return {
      title: "Warehouses",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Warehouses",
          active: true
        }
      ],
      add_warehouse_permission: permissions.add_warehouse_permission,
      warehouses: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    warehouses: {
      query: ALL_WAREHOUSES,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addWarehouseFn: 'stock/addNewWarehouse',
    }),
    async addWarehouse(data){
      await this.addWarehouseFn(data).then(resp => {
        this.updateWarehouses()
        if(resp.publicId){
          successToast(`New Warehouse ${resp.name} added successfully`)
        }
      })
    },
    updateWarehouses(){
      this.$apollo.queries.warehouses.refetch()
    }
  }
}
</script>

<style scoped>

</style>
